import React from "react";
import { createConfirmation, confirmable } from "react-confirm";
import PropTypes from "prop-types";
import styled from "styled-components";

import Button from "./Button";
import Close from "../Icons/Close";
import Modal from "./Modal";
import Link from "./Link";

const propTypes = {
  /**
   * whether to show the confirm dialog or not
   */
  show: PropTypes.bool,
  /**
   * function that determines whether to proceed or not
   */
  proceed: PropTypes.func,
  /**
   * header of the message
   */
  header: PropTypes.string,
  /**
   * props to different buttons, proceed and cancel
   */
  buttons: PropTypes.object,
  /**
   * confirm message
   */
  message: PropTypes.any.isRequired
};

const defaultProps = {
  buttons: {
    cancel: {
      variant: "secondary"
    }
  }
};

const Dialog = ({ show, proceed, message, header, buttons }) => {
  /**
   * variables
   */
  if (!buttons?.cancel) {
    buttons.cancel = defaultProps.buttons.cancel;
  }

  return (
    <Modal.Dark centered show={show} onHide={() => proceed(false)}>
      <div className="p-6">
        <div className="mb-10 d-flex align-items-center justify-content-between">
          <p className="fw-bold">{header}</p>
          <Link onClick={() => proceed(false)} className="text-decoration-none">
            <Close />
          </Link>
        </div>

        <p className="mb-10">{message}</p>

        <Buttons>
          <Button {...buttons?.cancel} onClick={() => proceed(false)}>
            {buttons?.cancel?.value || "Cancel"}
          </Button>
          <Button {...buttons?.proceed} onClick={() => proceed(true)}>
            {buttons?.proceed?.value || "Proceed"}
          </Button>
        </Buttons>
      </div>
    </Modal.Dark>
  );
};

/**
 * styles
 */
const Buttons = styled.div`
  gap: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;

export default createConfirmation(confirmable(Dialog));
